import React from 'react';
import {Link, hashHistory} from 'react-router';
import { connect } from 'react-redux'
import Header from '../Components/Header/HeaderLarge';
import '../index.css';
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';
import Badge from 'material-ui/Badge';
import Avatar from 'material-ui/Avatar';
import {List, ListItem} from 'material-ui/List';
import { changeTab, setPageName } from '../actions/environmentActions';
import TabStrip  from '../Components/TabStrip';
import AvatarIcon from '../Components/IconRender';


const isApple  = /iPhone|iPad|iPod/i
.test(navigator.userAgent);

const isAndroid  = /Android/i
.test(navigator.userAgent);


class HomePage extends React.Component {

  componentDidMount() {
    
      if(isApple || isAndroid) {
        if(window.screen.orientation) {
            try{
                window.screen.orientation.lock('portrait');
                //window.screen.orientation.unlock();
            }
            catch(err) {
                
            }
        }
    }
  }

  componentWillMount() {
      ListItem.defaultProps.disableTouchRipple = true; 
      ListItem.defaultProps.disableFocusRipple = true;
  }

  navigate = (page) => {
    this.props.setPageName(page.Name);

    var path = page.Path;
    if(page.ApplicationModuleID === 8 || page.ApplicationModuleID === 9 || page.ApplicationModuleID === 6) {
      path = path + "/" + page.ClientApplicationModuleMappingID
    }
    hashHistory.push(path);
  }
  
  render() {

      const { router } = this.props

    return (
         <div>
           <Header router={ router }>

             <div className="logo-home" />

             <div className="container trueno centered">
                {(this.props.member) && (
                  <h2 className="white greeting">Hi, {this.props.member.FirstName}!</h2>
                )}
            </div>
            </Header>
            <div className="container trueno"  >
              <br />
              <br />
              <br />
            
              <br />
              <Paper zDepth={1} >
                <List>
                    {(this.props.member) && (
                      <div>
                        {this.props.member.Modules.map((m, index) => (
                          <div key={index}>
                          <ListItem
                            leftAvatar={
                              <div>
                                 <AvatarIcon icon={m} />
                              </div>
                            }
                            style={{height:60}}
                            onClick={() => this.navigate(m)}
                            primaryText={m.Name}
                            rightIcon={ 
                              (m.ApplicationModuleID === 2 && this.props.newMessageCount > 0 
                                ? 
                                <Badge
                                  badgeContent={this.props.newMessageCount}
                                  secondary={true}
                                /> 
                                : 
                                ""
                              )
                            }
                            className="trueno"
                          />
                          {(index < (this.props.member.Modules.length-1)) && (
                            <Divider />
                          )}
                          </div>
                        ))}
                      </div>
                    )}
                </List>
              
              </Paper>
              {this.props.member.Modules.length == 5  && (
                  <div style={{height: 200, display:'block'}} ></div>
                )}
                   {this.props.member.Modules.length == 4  && (
                  <div style={{height: 260, display:'block'}} ></div>
                )}
                   {this.props.member.Modules.length == 6  && (
                  <div style={{height: 140, display:'block'}} ></div>
                )}
                  {this.props.member.Modules.length == 7  && (
                  <div style={{height: 80, display:'block'}} ></div>
                )}

              <br />
              <br />
              <br />
              <br />
              <br />
          </div>
          <TabStrip activeTab={1} />
      </div>
    );
  }
};


const mapDispatchToProps = (dispatch) => {
  return {
    setPageName: (name) => {
      dispatch(setPageName(name))
    }
  }
}

const mapStateToProps = (state) => ({
    member: state.thisApp.auth.member,
    newMessageCount: state.thisApp.messaging.globalNewMessageCount
})


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomePage)




// WEBPACK FOOTER //
// ./src/Pages/Home.js